import styled from 'styled-components';
import {BODY_TEXT_COLOR} from '../config/colors';

export const HeaderDiv = styled.div`
    color: ${props => props.color || BODY_TEXT_COLOR};
    font-size: 39px;
    line-height: 34px;
    font-weight: 700;
    font-family: 'Futura-Bold';
    text-align: center;
`;

export const SmallTextDiv = styled.div`
  color: ${props => props.color || BODY_TEXT_COLOR};
  font-size: 28px;
  line-height: 28px;
  font-weight: 700;
  font-family: 'Futura-Bold';
  text-align: center;
  margin: 10px;
`;

export const TextDiv = styled.div`
    font-family: 'Roboto', sans-serif;
    margin: 25px 0 25px;
    text-align: center;
    font-size: 18px;
    line-height: 28px;
    font-weight: 400;
    color: ${props => {
    if (props.color) {
      return props.color;
    }
    return BODY_TEXT_COLOR;
            
  }
};
    @media (max-width: 320px) {
        font-size: 16px;
        margin: 20px 10px 20px;
	}
`;

export const LargeHeaderTitle = styled.div`
    font-size: 40px;
    width: 72%;
    text-align: center;
    color: #7B9E4A;
`;



// WEBPACK FOOTER //
// ./src/modals/styled-components.js